
(function userControllerDefinition() {
    'use strict';
    angular.module('User')
        .controller('UserAddNewController', [
            '$scope', 'config', '$state', '$stateParams', '$translate', 'errorsExtend', 'adminUserService', 'authExtend', 'organizationalUnitService',
            function UserAddNewController($scope, config, $state, $stateParams, $translate, errors, adminUserService, authExtend, organizationalUnitService) {

                $scope.userOu =
                {
                    nickName: $stateParams.userName,                    
                    fullName: '',
                    password: $stateParams.password,
                    mail: '',
                    mailConfirm: '',
                    enabled: true,
                    organizationalUnitId: null,
                    organizationalUnitName: null,
                    isLdap: true
                };

                $scope.enableControls = true;

                $scope.title = 'UserAdd';
                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                organizationalUnitService.get().then(function getOk(result) {
                    $scope.organizationalUnits = result;
                }, function getError(error) {
                    errors.showError(error);
                });

                $scope.validMails = function () {
                    if ($scope.userOu.mail) {
                        if ($scope.userOu.mail !== $scope.userOu.mailConfirm) {
                            $scope.userForm.email2.$invalid = true;
                            $scope.userForm.email2.$valid = false;
                            return false;
                        } else {
                            $scope.userForm.email2.$invalid = false;
                            $scope.userForm.email2.$valid = true;
                            return true;
                        }
                    }
                    return false;
                }

                $scope.save = function () {
                    if (!$scope.validMails()) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('UserInvalidMailConfirm');
                        return false;
                    }

                    if (!$scope.userForm.$valid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    var userOu = angular.copy($scope.userOu);

                    return adminUserService.createFromLdap(userOu).then(function () {
                        $state.go('login');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("login");
                };

            }
        ]);
})();